<template>
  <el-pagination
    @size-change="sizeChange"
    @current-change="currentChange"
    :current-page="currentPage"
    :page-sizes="propPageSizes"
    :page-size="pageSize"
    background
    layout="total, sizes, prev, pager, next, jumper"
    :total="total"
    v-if="total > 0"
  >
  </el-pagination>
</template>

<script>
export default {
  props: {
    callback: {
      // 获取列表数据方法
      type: Function,
      default() {
        return function () {};
      },
    },
    propCurrentPage: {
      // 当前页
      type: [Number],
      default: 1,
    },
    propPageSizes: {
      // 配置每页显示多少条
      type: Array,
      default: function () {
        return [10, 20, 30, 40, 50];
      },
    },
    propPageSize: {
      // 默认每页显示条数
      type: [Number],
      default: 10,
    },
    total: {
      // 数据总条数
      type: [Number],
      default: 0,
    },
  },
  data() {
    return {
      currentPage: this.propCurrentPage, // 页面的当前页
      pageSize: this.propPageSize, // 页面分页器大小
    };
  },
  methods: {
    // 分页后置顶
    scrollTop(selector) {
      let element = (selector && document.querySelector(selector)) || window;
      element.scrollTo(0, 0);
    },
    // 改变当前页
    currentChange(val) {
      this.callback(undefined, val, this.pageSize);
      this.scrollTop();
    },
    // 改变每页显示多少条
    sizeChange(val) {
      this.callback(undefined, this.currentPage, val);
    },
  },
};
</script>

<style>
</style>
